export default __webpack_public_path__ + "static/media/car.d01077bf.jpg";